var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_4722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3347 0H1.9402C0.867445 0 0 0.846914 0 1.89401V24.3809C0 25.428 0.867445 26.28 1.9402 26.28H24.3347C25.4074 26.28 26.28 25.428 26.28 24.386V1.89401C26.28 0.846914 25.4074 0 24.3347 0ZM7.79674 22.3945H3.8958V9.84987H7.79674V22.3945ZM5.84627 8.14064C4.59387 8.14064 3.5827 7.12948 3.5827 5.8822C3.5827 4.63493 4.59387 3.62377 5.84627 3.62377C7.09355 3.62377 8.10471 4.63493 8.10471 5.8822C8.10471 7.12434 7.09355 8.14064 5.84627 8.14064ZM22.3945 22.3945H18.4987V16.2967C18.4987 14.8441 18.473 12.9706 16.4712 12.9706C14.4437 12.9706 14.1358 14.5567 14.1358 16.194V22.3945H10.2451V9.84987H13.9818V11.5642H14.0331C14.5515 10.5787 15.8245 9.53677 17.7185 9.53677C21.6656 9.53677 22.3945 12.134 22.3945 15.5114V22.3945Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_4722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.28,
    height: 26.28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLinkedin);
export default __webpack_public_path__ + "static/media/social-linkedin.9a39086f5280b75200a70dce8c00d7be.svg";
export { ForwardRef as ReactComponent };